import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { useNavigate } from "react-router-dom";
import { configurePrimeReactSpanishLocale } from "../../../utilities/primeReactLocale";
import { ProductService } from "../../../services/ProductService.js";
import { getCotizacionById } from "../../../services/CotizacionService.js";

const productService = new ProductService();

const FormBusquedaProductos = ({
  baseUrl,
  cliente,
  empresa,
  setEmpresa,
  tipoProducto,
  setTipoProducto,
  tiposProducto,
  setTiposProducto,
  desde,
  setDesde,
  hasta,
  setHasta,
  searchProductos,
  idCotizacion,
  loading,
  regularizarCotizacion,
  setRegularizarCotizacion,
}) => {
  const today = new Date();
  const navigate = useNavigate();
  const [tipoProductoTouched, setTipoProductoTouched] = useState(false);
  const [desdeTouched, setDesdeTouched] = useState(false);
  const [hastaTouched, setHastaTouched] = useState(false);

  // Empresas disponibles
  const empresasOptions = [
    { label: 'ALTAMIRA', value: 'ALTAMIRA' },
    { label: 'LA SIEMBRA', value: 'LA SIEMBRA' }
  ];

  const getTipoProductoByEmpresa = async (empresa) => {
    try {
      const tipos = await productService.getTiposProductoByEmpresa(baseUrl, empresa);
      if (Array.isArray(tipos)) {
        setTiposProducto(tipos);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getEmpresaByCotizacion = async (idCotizacion) => {
    try {
      const data = await getCotizacionById(baseUrl, idCotizacion);
      const empresaCotizacion = data.cotizacion.empresa;
      
      // Verificar si la empresa existe en las opciones
      const empresaExiste = empresasOptions.find(emp => emp.value === empresaCotizacion);
      
      if (empresaExiste) {
        setEmpresa(empresaCotizacion);
        await getTipoProductoByEmpresa(empresaCotizacion);
      } else {
        // Empresa de la cotización no disponible: se solicita selección manual
        console.warn("Empresa de cotización no encontrada en opciones:", empresaCotizacion);
      }
    } catch (error) {
      console.error("Error en getEmpresaByCotizacion:", error);
    }
  };

  useEffect(() => {
    configurePrimeReactSpanishLocale();
  }, []);

  // Cargar empresa por cotización (solo una vez)
  useEffect(() => {
    if (idCotizacion) {
      getEmpresaByCotizacion(idCotizacion);
    }
  }, [idCotizacion]);

  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const tomorrowHasta = new Date(today);
  tomorrowHasta.setDate(tomorrowHasta.getDate() + 2);



  return (
    <>
      <Button 
        label="Volver a Cotizaciones" 
        icon="pi pi-arrow-left" 
        rounded 
        outlined 
        onClick={() => {
          navigate("/cotizacion", { state: { isFormVisible: false } });
        }} 
      />

      <ProgressBar value="100" showValue={false} className="mt-3" />
      <div  id="clienteSeleccionado" className="surface-50 border-1 border-200 border-round p-3">
        <div className="flex align-items-center mb-3">
          <span className="text-900 font-semibold" style={{ fontSize: "1rem" }}>
            Cliente seleccionado
          </span>
        </div>
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-3">
            <small className="text-600 block mb-1">RUT</small>
            <div className="text-900 font-medium">{cliente?.rut || "-"}</div>
          </div>
          <div className="col-12 md:col-6 lg:col-3">
            <small className="text-600 block mb-1">Razón social</small>
            <div className="text-900 font-medium">{cliente?.razon_social || "-"}</div>
          </div>
          <div className="col-12 md:col-6 lg:col-3">
            <small className="text-600 block mb-1">Nombre fantasía</small>
            <div className="text-900 font-medium">{cliente?.nombre_fantasia || "-"}</div>
          </div>
          <div className="col-12 md:col-6 lg:col-3">
            <small className="text-600 block mb-1">Alias</small>
            <div className="text-900 font-medium">{cliente?.alias || "-"}</div>
          </div>
        </div>
      </div>
      <ProgressBar value="100" showValue={false}  />
      
      <h4 className="text-900 font-bold mt-4 mb-3">
        Nueva asignación de servicios para la cotización N° {idCotizacion}
      </h4>

      <div className="card">
          <div className="grid">
            <div className="field col-12 md:col-6 mt-2">
                <label htmlFor="empresa"><i className="pi pi-th-large mr-2 text-500"></i>Empresa *</label>
                <Dropdown
                  id="empresa"
                  value={empresa}
                  options={empresasOptions}
                  onChange={async (e) => {
                    setEmpresa(e.value);
                    setTipoProducto("");
                    await getTipoProductoByEmpresa(e.value);
                  }}
                  placeholder="Seleccione Empresa"
                  className="p-inputtext-lg w-full"
                  required
                  label="Empresa"
                  optionLabel="label"
                  disabled={loading}
                />
            </div>

            <div className="field col-12 md:col-6 mt-2">
              <label htmlFor="tipoProducto"><i className="pi pi-th-large mr-2 text-500"></i>Tipo Producto *</label>
              <MultiSelect
                id="tipoProducto"
                value={tipoProducto}
                onChange={(e) => {
                  setTipoProducto(e.value);
                  setTipoProductoTouched(true);
                }}
                onBlur={() => setTipoProductoTouched(true)}
                options={tiposProducto
                  .filter((option, index, self) =>
                    index === self.findIndex((t) => t.descripcion === option.descripcion)
                  )
                  .map((option) => ({
                    ...option,
                    label: option.descripcion,
                  }))
                }
                optionLabel="label"
                placeholder={`Seleccione Tipo Producto${empresa ? ` (${empresa})` : ""}`}
                filter
                required
                disabled={!empresa || loading}
                className={`p-inputtext-lg w-full align-items-center ${tipoProductoTouched && (!tipoProducto || tipoProducto.length === 0) ? 'p-invalid' : ''}`}
                style={{ minHeight: "50px" }}
              />
              {tipoProductoTouched && (!tipoProducto || tipoProducto.length === 0) && (
                <small className="p-error block mt-1">El tipo de producto es obligatorio</small>
              )}
            </div>
          </div>

          
          <div className="flex align-items-center gap-2">
            <Checkbox
              inputId="regularizarCotizacion"
              checked={!!regularizarCotizacion}
              onChange={(e) => {
                if (typeof setRegularizarCotizacion === "function") {
                  setRegularizarCotizacion(e.checked);
                }
              }}
              disabled={loading}
            />
            <label htmlFor="regularizarCotizacion" className="cursor-pointer">
              Modo regularización (sin restricción de fechas)
            </label>
          </div>

          <div className="grid mt-2">
          
            <div className="field col-12 md:col-6">
              <label htmlFor="desde"><i className="pi pi-calendar mr-1 text-500"></i>Fecha de inicio *</label>
              <Calendar
                id="desde"
                dateFormat="dd/mm/yy"
                showIcon
                showButtonBar
                value={desde}
                onChange={(e) => {
                  setDesde(e.value);
                  setDesdeTouched(true);
                }}
                onBlur={() => setDesdeTouched(true)}
                minDate={regularizarCotizacion ? null : tomorrow}
                placeholder="Seleccione una fecha"
                className={`p-inputtext-lg w-full ${desdeTouched && (!desde || desde === "") ? 'p-invalid' : ''}`}
                disabled={loading}
              />

              {desdeTouched && (!desde || desde === "") && (
                <small className="p-error block mt-1">El fecha de inicio es obligatorio</small>
              )}
            </div>

            <div className="field col-12 md:col-6">
                <label htmlFor="hasta"><i className="pi pi-calendar mr-2 text-500"></i>Fecha de termino *</label>
                <Calendar
                  id="hasta"
                  dateFormat="dd/mm/yy"
                  showIcon
                  showButtonBar
                  value={hasta}
                  onChange={(e) => {
                    setHasta(e.value);
                    setHastaTouched(true);
                  }}
                  onBlur={() => setHastaTouched(true)}
                  minDate={regularizarCotizacion ? null : tomorrowHasta}
                  placeholder="Seleccione una fecha"
                  className={`p-inputtext-lg w-full ${hastaTouched && (!hasta || hasta === "") ? 'p-invalid' : ''}`}
                  invalid
                  label="Fecha de termino *"
                  disabled={loading}
                />
                {hastaTouched && (!hasta || hasta === "") && (
                  <small className="p-error block mt-1">El fecha de termino es obligatorio</small>
                )}
            </div>
          </div>
          
          <div className="field col-12 md:col-12" style={{ display: "flex", justifyContent: "center" }}>
            <Button
              label="Buscar Productos"
              icon="pi pi-search"
              className="p-button-rounded"
              onClick={searchProductos}
              style={{ width: "400px" }}
              disabled={loading}
            />
          </div>
      </div>

    </>
  );
};

export default FormBusquedaProductos;
